<div class="pc-page-shell">
<div class="filter-container" [class.open]="isFilterOpen">
  <div class="filter" [ngClass]="{ 'dark-filter': isDarkMode(), 'light-filter': !isDarkMode() }">
    <div class="filter-header">
      <div class="filter-header__title">
        <mat-icon aria-hidden="true">filter_alt</mat-icon>
        <span>Table Filter</span>
      </div>
      <mat-icon class="close-btn" (click)="closeFilterDrawer()">close</mat-icon>
    </div>
    <form [formGroup]="filterForm" class="filter-body">
      <div class="filter-section">
        <h4>Date Range</h4>
        <app-custom-date-picker
          label="From Date"
          [controlname]="filterForm.controls['from_date']">
        </app-custom-date-picker>
        <app-custom-date-picker
          label="To Date"
          [controlname]="filterForm.controls['to_date']">
        </app-custom-date-picker>
      </div>
      <div class="filter-section">
        <h4>Operation</h4>
        <app-pc-multi-select-filter
          [lightMode]="!isDarkMode()"
          label=""
          placeholder="Select Operation"
          allLabel="All"
          [options]="cargoOperation"
          [(selected)]="selectedOperations">
        </app-pc-multi-select-filter>
      </div>
      <div class="filter-section">
        <h4>Port Name</h4>
        <input
          type="text"
          class="form-control"
          id="portName"
          formControlName="portName"
          placeholder="Select Port Name"
          (input)="filterPortNames($event)"
          [matAutocomplete]="autoPort" />
        <mat-autocomplete #autoPort="matAutocomplete">
          <mat-option *ngFor="let port of portNameSuggestions" [value]="port.portName">
            {{ port.portName }}
          </mat-option>
        </mat-autocomplete>
      </div>

      <div class="filter-section">
        <h4>Optimization Loss/Gain</h4>
        <label class="opt-lg-filter-label">Maneuvering</label>
        <app-pc-multi-select-filter
          [lightMode]="!isDarkMode()"
          label=""
          placeholder="Select Maneuvering"
          allLabel="All"
          [options]="optLossGainFilterOptions"
          [(selected)]="selectedOptLossGainManeuvering">
        </app-pc-multi-select-filter>

        <label class="opt-lg-filter-label">Cargo Ops</label>
        <app-pc-multi-select-filter
          [lightMode]="!isDarkMode()"
          label=""
          placeholder="Select Cargo Ops"
          allLabel="All"
          [options]="optLossGainFilterOptions"
          [(selected)]="selectedOptLossGainCargoOps">
        </app-pc-multi-select-filter>

        <label class="opt-lg-filter-label">Idle</label>
        <app-pc-multi-select-filter
          [lightMode]="!isDarkMode()"
          label=""
          placeholder="Select Idle"
          allLabel="All"
          [options]="optLossGainFilterOptions"
          [(selected)]="selectedOptLossGainIdle">
        </app-pc-multi-select-filter>
      </div>
    </form>
    <div class="filter-footer">
      <button type="button" class="btn clear-btn" (click)="clearClick()">
        <mat-icon>clear_all</mat-icon>
        Clear Filter
      </button>
      <button type="button" class="btn apply-btn" (click)="filterClick()">
        <mat-icon>filter_list</mat-icon>
        Apply Filter
      </button>
    </div>
  </div>
</div>
<div class="filter-overlay" *ngIf="isFilterOpen" (click)="closeFilterDrawer()"></div>

<div class="container">
  <br>
  <div class="page-top-actions">
    <button class="btn btn-light hover-button back" *ngIf="save" (click)="saveClick()">
      <mat-icon>save</mat-icon>
      <span>Save</span>
    </button>
    <button class="btn btn-light hover-button back" (click)="backClick()">
      <mat-icon>keyboard_backspace</mat-icon>
      <span>Back To Fleet View</span>
    </button>
    <button class="btn btn-light hover-button mail" (click)="exportClick()">
      <mat-icon>download</mat-icon>
      <span>Export</span>
    </button>
    <button
      type="button"
      class="page-filter-btn"
      (click)="isFilterOpen = true"
      matTooltip="Table Filter"
      aria-label="Open table filters">
      <mat-icon>filter_list</mat-icon>
    </button>
  </div>
  <div class="dashboard-grid">

    <div class="top-row">

      <!-- CURRENT PORT CARD -->
      <mat-card class="card current-leg" [ngClass]="{ 'dark-card': !isDarkMode() }">

        <div class="card-header">
          <span>Current Port</span>
        </div>
        <!-- SKELETON LOADER FOR CURRENT PORT -->
      <div class="current-port-wrapper current-port-skeleton" *ngIf="isLoading">
        <div class="port-title-row">
          <div class="skeleton-bar circle-skeleton"></div>
          <div class="port-title-text" style="width: 70%;">
            <div class="skeleton-bar" style="width: 60%; height: 20px; margin-bottom: 8px;"></div>
            <div class="skeleton-bar" style="width: 40%; height: 14px;"></div>
          </div>
        </div>

        <div class="port-row" *ngFor="let _ of [1, 2, 3, 4]">
          <div class="skeleton-bar" style="width: 35%;"></div>
          <div class="skeleton-bar" style="width: 45%;"></div>
        </div>
      </div>
        <div class="current-port-wrapper" *ngIf="!isLoading && currentLeg">

          <div class="port-title-row">

            <div class="port-icon">
              <mat-icon>location_on</mat-icon>
            </div>

            <div class="port-title-text">
              <div class="port-name">
                {{ positionData.port }}
              </div>

              <div class="operation-badge">
                {{ currentLeg.operation || "--" }}
              </div>

            </div>

          </div>

          <div class="port-row">
            <span>Date & Time</span>
            <span>{{ positionData.report_timestamp }}</span>
          </div>

          <div class="port-row">
            <span>Cargo Qty</span>
            <span>
              {{ positionData?.cargo_qty > 0 ? (positionData.cargo_qty | number:'1.0-2') + ' MT' : '-' }}
            </span>
          </div>

          <div class="port-row">
            <span>Last Reported Event</span>
            <span>{{ operationOnVsl }}</span>
          </div>

          <div class="port-row">
            <span>ETD</span>
            <span>{{ currentLeg.etd }}</span>
          </div>
          <div *ngIf="positionData?.reporttype === 'atSea'" class="at-sea-text">
            🚢 Vessel is currently AT SEA
          </div>
          <!-- <div class="port-row">
            <span>Report Type</span>
            <span>{{ reportType }}</span>
          </div> -->
        </div>

      </mat-card>

      <!-- MAP CARD -->
      <mat-card class="card map-card" [ngClass]="{ 'dark-card': !isDarkMode() }">

        <div class="card-header">
          <span>Vessel Position</span>

          <!-- LEGEND -->
         <div class="map-legend" *ngIf="!isLoading">
          <span class="legend-item">
            <span class="legend-ship-icon laden"></span>
            Laden
          </span>

          <span class="legend-item">
            <span class="legend-ship-icon ballast"></span>
            Ballast
          </span>
        </div>

        </div>

        <div class="map-container">
          <div id="Map" class="map-container"></div>
        </div>

      </mat-card>

    </div>

  </div>
  <h2 class="tableTitle" [ngClass]="{ 'dark-tableTitle': isDarkMode() }">
    Vessel View Table
  </h2>
  <div class="vessel-detail-header" [ngClass]="{ 'vessel-detail-header--dark': isDarkMode() }">
    <div class="vessel-detail-header__intro">
      <mat-icon class="vessel-detail-header__icon" aria-hidden="true">directions_boat</mat-icon>
      <div>
        <p class="vessel-detail-header__eyebrow">Selected Vessel</p>
        <h3 class="vessel-detail-header__title">{{ vesselHeaderName || '—' }}</h3>
      </div>
    </div>
    <div class="vessel-detail-header__meta">
      <div class="vessel-detail-header__item">
        <span class="vessel-detail-header__label">IMO Number</span>
        <span class="vessel-detail-header__value">{{ vesselHeaderImo || '—' }}</span>
      </div>
      <div class="vessel-detail-header__divider" aria-hidden="true"></div>
      <div class="vessel-detail-header__item">
        <span class="vessel-detail-header__label">Segment</span>
        <span class="vessel-detail-header__segment">{{ vesselHeaderSegment || '—' }}</span>
      </div>
    </div>
  </div>
  <div class="pc-performance-table-stack">
  <div class="table-view-banner table-view-banner--nested view-active">
    <mat-icon>list</mat-icon>
    <div class="banner-copy">
      <span class="banner-title">Vessel Port Detail</span>
    </div>
    <span class="banner-count">{{ elements?.length || 0 }} records</span>
  </div>
  <div class="detail-rail-table-wrapper pc-performance-table-wrapper pc-performance-table-wrapper--nested">
  <div
    class="detail-rail-table-scroll table-container scroll-bar pc-performance-table-scroll pc-data-table"
    [class.pc-data-table--dark]="isDarkMode()"
  >
    <table
      class="pc-performance-table mat-elevation-z8 printable-table"
      #table
      id="style-4"
      matSort
      [ngClass]="{
        'dark-table': isDarkMode(),
        'has-insights-col': isMerakiOperations()
      }"
    >
      <thead class="sticky-header">
        <tr>
          <th rowspan="2" class="centersno th-narrow">Sr No</th>
          <th rowspan="2" class="th-medium">Port</th>
          <th rowspan="2" class="th-narrow">Voyage</th>
          <th rowspan="2" class="th-narrow">Cargo</th>
          <th rowspan="2" class="th-medium">Operation</th>
          <th rowspan="2" class="th-medium" mat-sort-header="arrival_date_and_time">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Arrival</span>
              <mat-icon class="pc-col-header__info" matTooltip="Arrival Date &amp; Time">info</mat-icon>
            </span>
          </th>
          <th rowspan="2" class="th-medium" mat-sort-header="departure_date_and_time">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Departure</span>
              <mat-icon class="pc-col-header__info" matTooltip="Departure Date &amp; Time">info</mat-icon>
            </span>
          </th>
          <th rowspan="2" class="th-narrow">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Days</span>
              <mat-icon class="pc-col-header__info" matTooltip="Total Time (Days)">info</mat-icon>
            </span>
          </th>
          <th colspan="3" class="th-medium">
            <span class="pc-col-header">
              <span class="pc-col-header__label">BROB Arrival (MT)
</span>
              <mat-icon class="pc-col-header__info" matTooltip="ROB Arrival (MT)">info</mat-icon>
            </span>
          </th>
          <th colspan="3" class="th-medium">
            <span class="pc-col-header">
              <span class="pc-col-header__label">BROB Departure (MT)
</span>
              <mat-icon class="pc-col-header__info" matTooltip="ROB Departure (MT)">info</mat-icon>
            </span>
          </th>
          <th colspan="3" class="th-medium">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Actual Consumption (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="Actual consumption by operation leg (MT)">info</mat-icon>
            </span>
          </th>
          <th colspan="3" class="th-medium">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Optimization Consumption (MT)</span>
              <mat-icon
                class="pc-col-header__info"
                matTooltip="Enter Optimization Manoeuvring / Cargo Ops / Idle (MT) manually, then click Save."
              >info</mat-icon>
            </span>
          </th>
          <th colspan="3" class="th-medium">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Optimization Loss/Gain (MT)</span>
              <mat-icon
                class="pc-col-header__info"
                matTooltip="Optimization − Actual (MT). Green + = under optimization, Red − = over optimization."
              >info</mat-icon>
            </span>
          </th>
          <th rowspan="2" class="th-kpi">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Total Optimization</span>
              <mat-icon
                class="pc-col-header__info"
                matTooltip="Sum of Optimization Loss/Gain across Maneuvering, Cargo Ops, and Idle (MT)."
              >info</mat-icon>
            </span>
          </th>
          <th rowspan="2" class="th-kpi">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Total (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="Total Consumption (MT)">info</mat-icon>
            </span>
          </th>
          <th rowspan="2" class="th-kpi">
            <span class="pc-col-header">
              <span class="pc-col-header__label">CP Warranted (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="C/P Warranted Consumption (MT)">info</mat-icon>
            </span>
          </th>
          <th rowspan="2" class="th-kpi">
            <span class="pc-col-header">
              <span class="pc-col-header__label">CP Gain/Loss (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="Loss or Gain as per Charter Party (MT)">info</mat-icon>
            </span>
          </th>
          <th rowspan="2" class="th-kpi">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Optimization Consumption (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="Total Optimization Consumption (Maneuvering + Cargo Ops + Idle) (MT)">info</mat-icon>
            </span>
          </th>
          <th rowspan="2" class="th-kpi">
            <span class="pc-col-header">
              <span class="pc-col-header__label">Tech Gain/Loss (MT)</span>
              <mat-icon class="pc-col-header__info" matTooltip="Loss or Gain as per Technical Baseline (MT)">info</mat-icon>
            </span>
          </th>
          <th rowspan="2" class="remarks-head">Remarks</th>
          <th rowspan="2" class="insights-head" *ngIf="isMerakiOperations()">AI Insight</th>
          <th rowspan="2" class="report-head" *ngIf="subusername === 'demo'">Report</th>
        </tr>
        <tr>
          <th class="th-fuel">HSFO</th>
          <th class="th-fuel">VLSFO</th>
          <th class="th-fuel">MGO</th>
          <th class="th-fuel">HSFO</th>
          <th class="th-fuel">VLSFO</th>
          <th class="th-fuel">MGO</th>
          <th class="th-fuel">Manoeuvring</th>
          <th class="th-fuel">Cargo Ops</th>
          <th class="th-fuel">Idle</th>
          <th class="th-fuel">Manoeuvring</th>
          <th class="th-fuel">Cargo Ops</th>
          <th class="th-fuel">Idle</th>
          <th class="th-fuel">Maneuvering</th>
          <th class="th-fuel">Cargo Ops</th>
          <th class="th-fuel">Idle</th>
        </tr>
      </thead>
      <tbody *ngIf="isLoading">
  <tr *ngFor="let dummy of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" class="skeleton-row">
    <td class="centersno"><div class="skeleton-bar sno-skeleton"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <!-- BROB Arrival -->
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <!-- BROB Departure -->
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <!-- Actual Consumption -->
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <!-- Optimization Consumption Inputs -->
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <!-- Optimization Loss/Gain -->
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <!-- Totals & Variances -->
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>

    <!-- Action Columns -->
    <td class="remarks-col"><div class="skeleton-bar"></div></td>
    <td class="insights-col" *ngIf="isMerakiOperations()">
      <div class="skeleton-bar circle-skeleton"></div>
    </td>
    <td class="report-col" *ngIf="subusername === 'demo'">
      <div class="skeleton-bar icon-skeleton"></div>
    </td>
  </tr>
</tbody>
      <tbody *ngIf="!isLoading">
        <tr *ngFor="let element of paginatedData; let rowIndex = index">
          <td class="centersno">
            <input *ngIf="edit && element.reason === 'Drydock'" type="checkbox" class="checkBox"
              (change)="onCheckboxChange($event, element)" />
            {{ rowIndex + 1 }}
          </td>

          <td>{{ element.port }}</td>
          <td>{{ element.voyage_number }}</td>
          <td>{{ (element.cargo_quentity || 0) | number:'1.2-2' }}</td>
          <td>{{ element.operations }}</td>
          <td>{{ formatPortLocalAsUTC(element.arrival_date_and_time, element.port) }}</td>
          <td>{{ formatPortLocalAsUTC(element.departure_date_and_time, element.port) }}</td>
          <td>{{ element.total_time }}</td>

          <td>{{ formatFuelValue(element.brob_arrival_mt?.hsfo) }}</td>
          <td>{{ formatFuelValue(element.brob_arrival_mt?.vlsfo) }}</td>
          <td>{{ formatFuelValue(element.brob_arrival_mt?.lsgo) }}</td>

          <td>{{ formatFuelValue(element.brob_departure_mt?.hsfo) }}</td>
          <td>{{ formatFuelValue(element.brob_departure_mt?.vlsfo) }}</td>
          <td>{{ formatFuelValue(element.brob_departure_mt?.lsgo) }}</td>

          <td>{{ formatFuelValue(getActualLegConsumption(element, 'man')) }}</td>
          <td>{{ formatFuelValue(getActualLegConsumption(element, 'cargo_ops')) }}</td>
          <td>{{ formatFuelValue(getActualLegConsumption(element, 'idle')) }}</td>

          <td class="opt-cons-col">
            <input
              type="number"
              class="opt-cons-input"
              step="0.01"
              min="0"
              placeholder="—"
              [ngModel]="formatOptInputValue(getOptimizationLegConsumption(element, 'optimization_man'))"
              (ngModelChange)="setOptimizationLegConsumption(element, 'optimization_man', $event)"
              (keydown.enter)="saveOptimizationConsumption(element, true)"
              aria-label="Optimization Manoeuvring"
            />
          </td>
          <td class="opt-cons-col">
            <input
              type="number"
              class="opt-cons-input"
              step="0.01"
              min="0"
              placeholder="—"
              [ngModel]="formatOptInputValue(getOptimizationLegConsumption(element, 'optimization_cargo_ops'))"
              (ngModelChange)="setOptimizationLegConsumption(element, 'optimization_cargo_ops', $event)"
              (keydown.enter)="saveOptimizationConsumption(element, true)"
              aria-label="Optimization Cargo Ops"
            />
          </td>
          <td class="opt-cons-col opt-cons-col--actions">
            <div class="opt-cons-cell">
              <input
                type="number"
                class="opt-cons-input"
                step="0.01"
                min="0"
                placeholder="—"
                [ngModel]="formatOptInputValue(getOptimizationLegConsumption(element, 'optimization_idle'))"
                (ngModelChange)="setOptimizationLegConsumption(element, 'optimization_idle', $event)"
                (keydown.enter)="saveOptimizationConsumption(element, true)"
                aria-label="Optimization Idle"
              />
              <button
                type="button"
                class="opt-cons-save-btn"
                [disabled]="isSavingOptimizationConsumption(element) || isVesselMasked(element)"
                (click)="saveOptimizationConsumption(element, true)"
                [matTooltip]="isVesselMasked(element) ? 'Saving is disabled for masked vessels' : 'Save Optimization Consumption'"
                aria-label="Save Optimization Consumption"
              >
                <mat-icon>{{ isSavingOptimizationConsumption(element) ? 'hourglass_top' : 'save' }}</mat-icon>
              </button>
            </div>
          </td>

          <td
            class="opt-loss-gain-col"
            [ngStyle]="getOptimizationLossGainStyle(element, 'man')"
          >
            {{ formatOptimizationLossGain(element, 'man') }}
          </td>
          <td
            class="opt-loss-gain-col"
            [ngStyle]="getOptimizationLossGainStyle(element, 'cargo_ops')"
          >
            {{ formatOptimizationLossGain(element, 'cargo_ops') }}
          </td>
          <td
            class="opt-loss-gain-col"
            [ngStyle]="getOptimizationLossGainStyle(element, 'idle')"
          >
            {{ formatOptimizationLossGain(element, 'idle') }}
          </td>
          <td
            class="opt-loss-gain-col"
            [ngStyle]="getTotalOptimizationLossGainStyle(element)"
          >
            {{ formatTotalOptimizationLossGain(element) }}
          </td>

          <td>{{ getTotalConsumptionMt(element) }}</td>
          <td>{{ getCpWarrantedConsumptionMt(element) }}</td>
          <td [ngStyle]="getLossGainStyle(element.cp_overall_mt)">
            {{ formatLossGainValue(element.cp_overall_mt) }}
          </td>
          <td>{{ getTotalOptimizationConsumptionMt(element) }}</td>
          <td [ngStyle]="getLossGainStyle(element.design_overall_mt)">
            {{ formatLossGainValue(element.design_overall_mt) }}
          </td>

          <td class="remarks-col">
            <div class="remarks-col__content">
              <ng-container *ngIf="editedRowIndex !== rowIndex || editedColumnName !== 'remarks'">
                <span class="remarks-col__text" [matTooltip]="element.remarks || ''">{{ element.remarks }}</span>
                <button
                  type="button"
                  (click)="editCell(rowIndex, 'remarks')"
                  class="remarks-edit-btn"
                  aria-label="Edit remarks">
                  <mat-icon class="edit">edit</mat-icon>
                </button>
              </ng-container>
              <ng-container *ngIf="editedRowIndex === rowIndex && editedColumnName === 'remarks'">
                <input
                  type="text"
                  [(ngModel)]="element.remarks"
                  (focusout)="saveRemarks(element)"
                  placeholder="Enter remark" />
              </ng-container>
            </div>
          </td>

          <td class="insights-col" *ngIf="isMerakiOperations()">
            <div class="insights-col__inner">
              <button
                type="button"
                class="ai-btn"
                [class.ai-btn--waiting]="!hasReport(element)"
                (click)="openInsights(element, $event)"
                [matTooltip]="hasReport(element) ? 'View AI insights' : 'Insights available when report is ready'"
                matTooltipPosition="above"
                aria-label="View AI insights">
                <mat-icon class="ai-icon">auto_awesome</mat-icon>
              </button>
            </div>
          </td>

          <td class="report-col">
            <div class="report-col__inner">
              <button
                type="button"
                class="report-download-btn"
                [class.report-download-btn--disabled]="!getReportS3Url(element) || isReportDownloading(element)"
                [disabled]="!getReportS3Url(element) || isReportDownloading(element)"
                (click)="download(element, $event)"
                matTooltip="Download report"
                matTooltipPosition="left"
                aria-label="Download report"
                [disabled]="subusername === 'demo'">
                <mat-icon>{{ isReportDownloading(element) ? 'hourglass_top' : 'download' }}</mat-icon>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  </div>
  <mat-paginator
    class="pc-performance-paginator"
    [length]="elements?.length"
    [pageSizeOptions]="pageSizeOptions"
    [pageSize]="itemsPerPage"
    (page)="onPageChange($event)"
    showFirstLastButtons
    [ngClass]="{ 'dark-paginator': isDarkMode() }"
  ></mat-paginator>
  </div>
  <br>
  <br>


  <br>
  <br>
</div>
</div>